<script setup>
import ImageSection from "@/Pages/Info/Partials/ImageSection.vue";
</script>

<template>
    <ImageSection>
        <template #subtitle>
            <slot name="subtitle"></slot>
        </template>
        <template #title>
            <slot name="title"></slot>
        </template>
        <template #content>
            <slot name="content"></slot>
        </template>
        <template #image>
            <img
                src="/assets/01KRKTC6QKHKAAFFWDCGYGRBK8.webp"
                alt="Qualta Guide list screenshot"
                width="2432"
                height="1442"
                class="dark:hidden -mb-12 w-[57rem] max-w-none aspect-[1876/1300] rounded-tl-lg bg-gray-800 ring-1 ring-white/10"
                loading="lazy"
            />
            <img
                src="/assets/01KRKTC57Q5MP30X6AQ2SS08FB.webp"
                alt="Qualta Guide list screenshot"
                width="2432"
                height="1442"
                class="hidden dark:block -mb-12 w-[57rem] max-w-none aspect-[1868/1294] rounded-tl-lg bg-gray-800 ring-1 ring-white/10"
                loading="lazy"
            />
        </template>
    </ImageSection>
</template>

<style scoped></style>
